import type { StepMap, StepSource } from "@/Modules/Models/Domain/OnBoarding";
import {
  AnswersIds,
  ChoicesName,
  StepId,
  YesOrNoAnswer,
  AREA_EXTRA_THERAPIST_KNOW,
  WITHOUT_THERAPIST,
  SUBSCRIPTION_ACTIVE,
  SUBSCRIPTION_ACTIVE_THERAPIST_KNOWN,
  SUBSCRIPTION_ACTIVE_LAST_THERAPIST,
  EMPTY_AREA,
  PRIVACY_POLICY_EMPTY,
} from "@/Modules/Models/Domain/OnBoarding";

// @ts-expect-error THER-6617
export const patientComeBackstepSource: StepSource = {
  [StepId.USER_CHOOSE_LAST_THERAPIST]: {
    highlightedTitle: "onboarding.user_choose_last_therapist.title",
    subtitle: "onboarding.user_choose_last_therapist.subtitle",
    setTherapistSubtitleName: true,
    infoField: ["onboarding.user_choose_last_therapist.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.GO_TO_LAST_THERAPIST,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        options: [
          {
            title: "onboarding.user_choose_last_therapist.yes",
            value: YesOrNoAnswer.YES,
          },
          {
            title: "onboarding.user_choose_last_therapist.no",
            value: YesOrNoAnswer.NO,
          },
        ],
      },
    ],
  },
  [StepId.MAIN_AREA]: {
    title: "onboarding.step.main_area.title",
    highlightedTitle: "onboarding.step.main_area.title_highlighted",
    subtitle: "onboarding.step.main_area.subtitle",
    infoField: ["onboarding.step.main_area.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.MAIN_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.MAIN_AREA,
      },
    ],
  },
  [StepId.SUB_AREA]: {
    title: "onboarding.step.subarea.title",
    highlightedTitle: "onboarding.step.subarea.title_highlighted",
    actionButton: true,
    infoSpecialMainArea: "depression",
    components: [
      {
        id: AnswersIds.SUB_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.SUB_AREA,
        filterChoices: {
          param: "isCouple",
          value: false,
        },
      },
    ],
  },
  [StepId.THERAPIST_NAME]: {
    highlightedTitle: "onboarding.step.therapist_name.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_NAME,
        value: "",
        mandatory: true,
        type: "text",
        name: "TcInput",
        placeholder: "onboarding.step.therapist_name.placeholder",
        maxCharacters: 100,
        minCharacters: 5,
      },
    ],
  },
  [StepId.TIME_AFFECTED]: {
    highlightedTitle: "onboarding.step.time_affected.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.TIME_AFFECTED,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        options: [
          {
            title: "onboarding.step.time_affected.option1.title",
            value: "days",
          },
          {
            title: "onboarding.step.time_affected.option2.title",
            value: "weeks",
          },
          {
            title: "onboarding.step.time_affected.option3.title",
            value: "month",
          },
          {
            title: "onboarding.step.time_affected.option4.title",
            value: "months",
          },
          {
            title: "onboarding.step.time_affected.option5.title",
            value: "years",
          },
        ],
      },
    ],
  },
  [StepId.TELL_ME_MORE]: {
    title: "onboarding.step.tell_me_more.title",
    highlightedTitle: "onboarding.step.tell_me_more.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.tell_me_more.info"],
    components: [
      {
        id: AnswersIds.TELL_ME_MORE,
        value: "",
        mandatory: false,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.tell_me_more.placeholder",
        label: "onboarding.step.tell_me_more.label",
      },
    ],
  },
  [StepId.THERAPIST_GENDER_PREFERENCES]: {
    title: "onboarding.step.therapist_gender_preferences.title",
    highlightedTitle: "onboarding.step.therapist_gender_preferences.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.therapist_gender_preferences.info"],
    components: [
      {
        id: AnswersIds.THERAPIST_GENDER_PREFERENCES,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDER_PREFERENCES,
      },
    ],
  },
  [StepId.THERAPIST_AVAILABILITIES]: {
    title: "onboarding.step.therapist_availabilities.title",
    highlightedTitle: "onboarding.step.therapist_availabilities.title_highlighted",
    subtitle: "onboarding.step.therapist_availabilities.subtitle",
    infoField: ["onboarding.step.therapist_availabilities.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_AVAILABILITY,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.AVAILABILITIES,
      },
    ],
  },
};

// @ts-expect-error THER-6617
export const patientComeBackStepMap: StepMap = {
  [StepId.WELCOME_AGAIN]: [
    {
      id: PRIVACY_POLICY_EMPTY,
      nextStep: StepId.PRIVACY_POLICY,
    },
    {
      id: WITHOUT_THERAPIST,
      nextStep: StepId.MAIN_AREA,
    },
    {
      id: "*",
      nextStep: StepId.USER_CHOOSE_LAST_THERAPIST,
    },
  ],
  [StepId.USER_CHOOSE_LAST_THERAPIST]: [
    {
      id: SUBSCRIPTION_ACTIVE_LAST_THERAPIST,
      nextStep: StepId.THERAPIST_ASSIGNED,
    },
    {
      id: YesOrNoAnswer.YES,
      nextStep: StepId.CHECKOUT,
    },
    {
      id: YesOrNoAnswer.NO,
      nextStep: StepId.MAIN_AREA,
    },
  ],
  [StepId.PRIVACY_POLICY]: [
    {
      id: WITHOUT_THERAPIST,
      nextStep: StepId.MAIN_AREA,
    },
    {
      id: "*",
      nextStep: StepId.USER_CHOOSE_LAST_THERAPIST,
    },
  ],
  [StepId.MAIN_AREA]: [
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.THERAPIST_NAME,
    },
    {
      id: EMPTY_AREA,
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
    {
      id: "*",
      nextStep: StepId.SUB_AREA,
    },
  ],
  [StepId.SUB_AREA]: [
    {
      id: "*",
      nextStep: StepId.TIME_AFFECTED,
    },
  ],
  [StepId.THERAPIST_NAME]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.TIME_AFFECTED]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.TELL_ME_MORE]: [
    {
      id: SUBSCRIPTION_ACTIVE_THERAPIST_KNOWN,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.CHECKOUT,
    },
    {
      id: "*",
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
  ],
  [StepId.THERAPIST_GENDER_PREFERENCES]: [
    {
      id: "*",
      nextStep: StepId.THERAPIST_AVAILABILITIES,
    },
  ],
  [StepId.THERAPIST_AVAILABILITIES]: [
    {
      id: "*",
      nextStep: StepId.REGISTER_USER_COME_BACK,
    },
  ],
  [StepId.REGISTER_USER_COME_BACK]: [
    {
      id: SUBSCRIPTION_ACTIVE,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: "*",
      nextStep: StepId.CHECKOUT,
    },
  ],
  [StepId.CHECKOUT]: [
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: WITHOUT_THERAPIST,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: "*",
      nextStep: StepId.THERAPIST_ASSIGNED,
    },
  ],
  [StepId.THERAPIST_ASSIGNED]: [
    {
      id: "*",
      nextStep: StepId.MAIN_AREA,
    },
  ],
};
